import React, { Component } from 'react';
import FileUploader from './../../../commons/FileUploader.js';
import DownloadFile from './../../../commons/DownloadFile.js';

export default class GeoMarker extends Component {
	render() {
		return(
			<div className="dump-ingestion-wrapper">
				<div className="white-box">
					<div className="page-header-title">
						Geo Marker
					</div>
					<div>
						<DownloadFile title="Download Geo Marker Dump" url="dump/space/geomarkers"/>
					</div>
					<div className="top-thirty">
						<FileUploader url="ingest/space/geomarker"/>
					</div>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/screens/SpaceOperations/Components/GeoMarker.js